import VoiceOrderNavItem from "./NavItem/VoiceOrderNavItem/VoiceOrderNavItem";
import BundlesNavItem from "./NavItem/BundlesNavItem/BundlesNavItem";
import NewlyAddedNavItem from "./NavItem/NewlyAddedNavItem/NewlyAddedNavItem";
import PromotionsNavItem from "./NavItem/PromotionsNavItem/PromotionsNavItem";
import RecommendedSkusNavItem from "./NavItem/RecommendedSkusNavItem/RecommendedSkusNavItem";
import classes from "./NavMenu.module.css";

export const NavMenu = () => {
  return (
    <nav className={classes["nav-menu"]}>
      <ul className={classes["nav-menu__list"]}>
        <li className={classes["nav-menu__list-item"]}>
          <VoiceOrderNavItem />
        </li>
        <li className={classes["nav-menu__list-item"]}>
          <BundlesNavItem />
        </li>
        <li className={classes["nav-menu__list-item"]}>
          <PromotionsNavItem />
        </li>
        <li className={classes["nav-menu__list-item"]}>
          <NewlyAddedNavItem />
        </li>
        <li className={classes["nav-menu__list-item"]}>
          <RecommendedSkusNavItem />
        </li>
      </ul>
    </nav>
  );
};

export default NavMenu;
